import React, { useContext, useEffect, useState } from 'react';
import './carousal.css';
import Searchbar from '../../Components/Searchbar';
import Navbar from '../../Components/Navbar';
import Filtersearch from '../../Components/Filtersearch';
import { addcontext } from '../../ContextShare/ContextShare';
import LatestSession from './LatestSession';
import LatestEvents from './LatestEvents';
import ExclusiveVideos from './ExclusiveVideos';
import Member from './Member';
import Footer from '../../Components/Footer';
import { useNavigate } from 'react-router-dom';
import klabackground from '../../Assets/KLA new.jpg'
import klalogo from '../../Assets/logo1.png'
import speakerpic from '../../Assets/matting_OIP.png'
import kla1 from '../../Assets/Sabha 1.jpg'
import kla2 from '../../Assets/sabha 2.jpg'
import kla3 from '../../Assets/sabha 3.jpg'
import kla4 from '../../Assets/NIYAMASABHAMANDIRAM 03.jpg'
import kla7 from '../../Assets/Niyamasabha building lighting .JPG'
import kla6 from '../../Assets/DSC_0034.JPG'
import kla8 from '../../Assets/Niyamasabha front gate .JPG'
import kla5 from '../../Assets/DSC05473.JPG'
import CalendarOfSittings from '../../Components/CalendarOfSittings';
import { CarousalImageGet, GetLiveButtonApi, initialSpeakerInfo } from '../../Services/allApi';
import language from '../../language.json'


function Carousal() {
  const baseUrl = process.env.REACT_APP_BASEURL
  const [currentLanguage, setCurrentLanguage] = useState();
  const { langChanged, setlangChanged } = useContext(addcontext)
  const [imageIndex, setImageIndex] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [selectedEvent, setSelectedEvent] = useState('');
  const [selectedSession, setSelectedSession] = useState('');
  const [selectedKLA, setSelectedKLA] = useState('');
  const [selectedMember, setSelectedMember] = useState('');
  const [selectedFromDate, setselectedFromDate] = useState('')
  const [selectedToDate, setselectedToDate] = useState('')
  const [filterData, setFilterData] = useState({ sessionvalue: '', klavalue: '', eventvalue: '', membervalue: '' })
  const { isFilterOpen, setFilterOpen } = useContext(addcontext)
  const [isMaintenance, setisMaintenance] = useState(false)
  const [isLive, setIsLive] = useState(false);
  const [speakerInfo, setspeakerInfo] = useState()
  const [isLangEng, setIsLangEng] = useState(true)
  const [imageUrls, setImageUrls] = useState([])
  const{InitialSearchQuery,setInitialSearchQuery}=useContext(addcontext)

  //     const imageUrls = [
  //         // kla8,kla5,kla4,kla1,kla7
  // ]
// clear search value
useEffect(()=>{
  setInitialSearchQuery()
},[])
  // reset values from filter
  const removeValuesFromFilter = () => {
    if (!isFilterOpen) {
      setSelectedSession('')
      setSelectedKLA('')
      setSelectedEvent('')
      setSelectedMember('')
      setselectedFromDate('')
      setselectedToDate('')
    }
  }
  // check for maintenance on or off
  useEffect(() => {
    if (isMaintenance) {
      navigate('/maintenance')
    }
  }, [isMaintenance])

  // remove values from filter
  useEffect(() => {
    removeValuesFromFilter()
  }, [isFilterOpen])

  // change the image to carousal one by one 
  useEffect(() => {
    if (!isFilterOpen) {
      const timer = setInterval(() => {
        setImageIndex((prevIndex) => (prevIndex + 1) % imageUrls?.length);
      }, 5000);
      return () => clearInterval(timer);
    }
  }, [isFilterOpen, imageUrls]);

  const handlelogin = () => {
    navigate('login')
  }
  const navigate = useNavigate()

  // useEffect(() => {
  //   IsLiveEnabled()
  // }, [])
  // // check the live is enabled
  // const IsLiveEnabled = async () => {
  //   const res = await GetLiveButtonApi()
  //   // console.log(res);
  // }
  useEffect(() => {
      // check if live is ongoing or not
  const getLiveButtonInitial = async () => {
    const result = await GetLiveButtonApi()
    setIsLive(result?.data?.is_active)
    console.log(result);
  }

  getLiveButtonInitial();
  }, []); // Run once on component mount to fetch calendar data

  useEffect(() => {
    // get speaker info initially
 const GetSpeakerrInfo = async () => {
   const res = await initialSpeakerInfo()
   console.log(res);
   setspeakerInfo(res?.data?.data[0])
 }

 GetSpeakerrInfo();
 }, []); // Run once on component mount to fetch calendar data

  useEffect(() => {
     // get speaker info initially
  const GetSpeakerrInfo = async () => {
    const res = await initialSpeakerInfo()
    console.log(res);
    setspeakerInfo(res?.data?.data[0])
  }

  GetSpeakerrInfo();
  }, []); // Run once on component mount to fetch calendar data

  // change language
  const handleLanguageChange = () => {
    setlangChanged(langChanged + 1)
    if (currentLanguage == 'en') {
      // setCurrentLanguage('mal')
      localStorage.setItem('language', 'mal')
      setCurrentLanguage(localStorage.getItem('language'))
    }
    else {
      // setCurrentLanguage('en')
      localStorage.setItem('language', 'en')
      setCurrentLanguage(localStorage.getItem('language'))


    }
  }
  useEffect(() => {
    setCurrentLanguage(localStorage.getItem('language') || 'en')
  }, [currentLanguage])
  
  // get the carousal images initally
  // useEffect(() => {
  //   getCarousalImages()
  // }, [])

  // get the carousal images initally
  // const getCarousalImages = async () => {
  //   const res = await CarousalImageGet();
  //   console.log(res);
  //   const newimarray = res?.data?.map((item) => baseUrl + item?.home_image);
  //   console.log(newimarray);
  //   setImageUrls(newimarray);
  // };

  useEffect(() => {
    const getCarousalImages = async () => {
      const res = await CarousalImageGet();
      console.log(res);
      const newimarray = res?.data?.map((item) => baseUrl + item?.home_image);
      console.log(newimarray);
      setImageUrls(newimarray);
    };

    getCarousalImages();
  }, []); // Run once on component mount to fetch calendar data
  return (
    <>
      <div id='carousel-container' className='relative overflow-hidden' style={{ height: '100lvh' }} >
        {imageUrls?.map((url, index) => (
          <div key={index} className={index === imageIndex ? 'carousel-image active' : 'carousel-image top-0 left-0 '} style={{ position: 'absolute', width: '100%', height: '85%' }} >
            <img src={url} alt="" className={`md:h-full h-3/4  ${isFilterOpen ? 'blur img' : 'img'}`} style={{ width: '100%' }} />

            {/* Container for top most components : logo,heading searchbar... */}
            <div className='image-text top-0 pt-2 pb-2 pl-2 text-white flex absolute w-full bg-primary' style={{ fontFamily: "Ropa Sans", height: '100' }}>
              <div className='flex flex-row w-full h-full '>
                {/* Div for top left logo */}
                <div className=' flex items-center' style={{ height: '40px' }}>
                  <img className='colorChangeImg sm:w-28 w-24 sm:h-16 h-14' src={klalogo} alt="Kerala Govt" />
                </div>
                {/* Heading topleft */}
                <div className=' md:w-3/12 lg:3/12 xl:2/12  w-full flex items-center' style={{ height: '40px' }}>
                  <h1 className='md:ms-4 ms-1 md:text-sm lg:text-lg text-xs'>{language.HomePage1[currentLanguage]}</h1>
                </div>
                {/* Search bar */}

                <div className='lg:flex justify-center w-full h-full -ms-12 relative hidden' style={{ zIndex: '999' }}>
                  <Searchbar searchValue={searchValue} setSearchValue={setSearchValue} />
                </div>


                {/* Live,Dark mode ,malayalambuttons */}
                <div className='md:flex flex-row hidden ' style={{ height: '40px', width: '110px', visibility: 'hidden' }}>
                  <button onClick={e => alert('live')} className={`${isFilterOpen ? 'blur sm:-ms-28 -ms-10  mt-0' : 'sm:-ms-28 -ms-10  mt-0 z-50'} `} style={{ width: '100%', height: '100%', borderRadius: '6px', backgroundColor: '#001F33' }}>
                    Live</button>
                </div>

                {isLive && (
                  <a
                    href="http://103.251.43.36:8080/players/kla.html"
                    target="_blank"
                    className="flex flex-row"
                    style={{ height: '40px', width: '110px' }}
                  >
                    <button
                      className={`${isFilterOpen ? 'blur sm:-ms-20 -ms-12 mt-0' : 'sm:-ms-20 -ms-12 mt-0 z-50'}  
                  ${currentLanguage === 'en' ? 'md:text-sm text-xs' : 'text-[10px]'} 
                  border hover:bg-indigo-600 transform duration-500 ease-in-out`}
                      style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '6px',
                        color: '#fff', // White text color
                        border: '2px solid transparent', // Transparent border to allow animation
                        position: 'relative',
                        overflow: 'hidden',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Box shadow for depth
                      }}
                    >
                      <span className="button-text">{language.Live[currentLanguage]}</span>
                      <div className="border-animation"></div>
                    </button>
                  </a>
                )}

                <style jsx>{`
  .button-text {
    position: relative;
    z-index: 1;
  }

  .border-animation {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 2px solid transparent;
    border-radius: 6px;
    z-index: 0;
    box-sizing: border-box;
    animation: borderAnimation 2s linear infinite;
  }

  @keyframes borderAnimation {
    0% {
      border-color: transparent;
      border-width: 2px;
      transform: scale(1);
    }
    25% {
      border-color: #1E90FF; // DodgerBlue color
      border-width: 4px;
      transform: scale(1.05);
    }
    50% {
      border-color: #FF00FF; // Magenta color
      border-width: 2px;
      transform: scale(1);
    }
    75% {
      border-color: #1E90FF; // DodgerBlue color
      border-width: 4px;
      transform: scale(1.05);
    }
    100% {
      border-color: transparent;
      border-width: 2px;
      transform: scale(1);
    }
  }
`}</style>



                <div className='flex flex-row' style={{ height: '40px', width: '118px' }}>
                  <button onClick={handleLanguageChange} className={`${isFilterOpen ? 'blur sm:-ms-16 -ms-10  mt-0' : 'sm:-ms-16 -ms-10  mt-0 z-50 '} ${currentLanguage == 'mal' ? 'md:text-sm text-xs' : 'text-xs'} border hover:bg-indigo-600 transform duration-500 ease-in-out`} style={{ width: '100%', borderRadius: '6px' }}>
                    {currentLanguage == 'en' ? 'മലയാളം  ' : 'English'}</button>
                </div>

                {/* <div className='flex flex-row  ' style={{height: '40px', width: '110px' }}>
                                    <button onClick={e => alert('Dark')} className={`${isFilterOpen ? 'blur sm:-ms-12 -ms-8  mt-0 ' : 'sm:-ms-12 -ms-8  mt-0'} ${currentLanguage=='en'?'md:text-sm text-xs':'text-xs'}`} style={{ width: '100%', height: '100%', borderRadius: '6px', backgroundColor: '#001F33' }}>
                                        <i className="fa-solid fa-moon me-1"></i>Dark</button>
                                </div> */}
              </div>
            </div>

            {/* search bar for smaller screens */}
            <div className='mt-1 top-16 justify-center text-white flex absolute w-full lg:hidden'>
              <div className='flex justify-center w-full h-full relative  ' style={{ zIndex: '999' }}>
                <Searchbar searchValue={searchValue} setSearchValue={setSearchValue} />
              </div>
            </div>


            {/* speaker Container for Text fields eg:speaker name,photo */}
            <div
              className={`${isFilterOpen ? 'blur flex items-center absolute sm:right-12 left-8 ' : 'flex items-center absolute sm:left-12 left-8'
                }`}
              style={{
                top: '150px',
                fontFamily: 'Ropa Sans',
                color: 'black', // Changed to black for better contrast with light background
              }}
            >
              <div
                className="flex flex-col items-center justify-center transition-transform transform hover:scale-105 px-1 py-1"
                style={{
                  background: 'rgba(255, 255, 255, 0.2)', // Light background with low opacity
                  // padding: '5px',
                  borderRadius: '12px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                  border: '1px solid rgba(255, 255, 255, 0.3)', // Light border with low opacity
                  backdropFilter: 'blur(10px)', // Background blur for the mirror effect
                }}
              >
                <img
                  src={`${baseUrl}${speakerInfo?.speaker_image}`}
                  className="md:w-32 w-20 md:h-32 h-20 rounded-2xl border border-dashed border-blue-500 shadow-xl object-cover" // Light blue border
                  alt="speaker image"
                />
                <h3 className="text-center md:text-lg text-xs text-gray-300 font-bold"> {/* Blue text for name */}
                  {currentLanguage === 'en' ? speakerInfo?.speaker_name : speakerInfo?.mal_speaker_name}
                </h3>
                <h5 className="text-center md:text-sm text-xs text-gray-400"> {/* Gray text for salutation */}
                  {currentLanguage === 'en' ? speakerInfo?.salutation : speakerInfo?.mal_salutation}
                </h5>
              </div>
            </div>



            {/* Main heading */}
            <div className={isFilterOpen ? 'blur flex items-center absolute text-center w-full md:bottom-10 bottom-52' : 'flex items-center absolute text-center w-full md:bottom-10 bottom-52'} style={{ fontFamily: "Ropa Sans", color: 'transparent' }} >
              <h2 className='w-full md:text-4xl text-3xl font-bold text-highlight' style={{ fontFamily: "Russo One" }}>{language.HomePage2[currentLanguage]}</h2>
            </div>

            {/* for navigation button to diffrernt slides */}
            {!isFilterOpen && <div className=' flex-col absolute right-0 flex text-white' style={{ top: '300px', zIndex: '998' }}>
              <div><button className={imageIndex == 0 && 'font-bold'} onClick={e => setImageIndex(0)}>1{imageIndex == 0 && <i className="fa-solid fa-minus ms-1"></i>}</button></div>
              <div><button className={imageIndex == 1 && 'font-bold'} onClick={e => setImageIndex(1)}>2{imageIndex == 1 && <i className="fa-solid fa-minus ms-1"></i>}</button></div>
              <div><button className={imageIndex == 2 && 'font-bold'} onClick={e => setImageIndex(2)}>3{imageIndex == 2 && <i className="fa-solid fa-minus ms-1"></i>}</button></div>
              <div><button className={imageIndex == 3 && 'font-bold'} onClick={e => setImageIndex(3)}>4{imageIndex == 3 && <i className="fa-solid fa-minus ms-1"></i>}</button></div>
              <div><button className={imageIndex == 4 && 'font-bold'} onClick={e => setImageIndex(4)}>5{imageIndex == 4 && <i className="fa-solid fa-minus ms-1"></i>}</button></div>
            </div>}

          </div>
        ))}

{isFilterOpen && <div className=' flex absolute justify-center left-0 right-0' style={{ top: '80px', fontFamily: "Ropa Sans", color: 'white', zIndex: '1001' }} >
              <Filtersearch selectedSession={selectedSession} setSelectedSession={setSelectedSession} selectedKLA={selectedKLA} setSelectedKLA={setSelectedKLA} selectedEvent={selectedEvent} setSelectedEvent={setSelectedEvent} selectedMember={selectedMember} setSelectedMember={setSelectedMember} selectedFromDate={selectedFromDate} setselectedFromDate={setselectedFromDate} selectedToDate={selectedToDate} setselectedToDate={setselectedToDate} />
              {/* selectedSession={selectedSession} setSelectedSession={setSelectedSession}  */}
            </div>
            }

        <div className={isFilterOpen ? 'blur flex-col absolute right-0 left-0 flex text-white md:bottom-10 bottom-60' : ' flex-col absolute right-0 left-0 flex text-white md:bottom-10 bottom-60'}>
          <Navbar />

        </div>
      </div>


      {/* Latest Sessions */}
      <div className='sm:mt-24 -mt-36'>
        <LatestSession />
      </div>
      {/* Latest Events */}
      {/* <div className='sm:mt-24 mt-16'>
                <LatestEvents/>
            </div> */}

      {/* Exclusive videos */}
      <div className='sm:mt-24 mt-16'>
        <ExclusiveVideos />
      </div>

      <div className='sm:mt-24 mt-16'>
        <CalendarOfSittings />
      </div>

      {/* Members */}
      {/* <div className='sm:mt-24 mt-16'>
                <Member/>
            </div> */}

      <div className='sm:mt-24 mt-16'>
        <Footer />
      </div>
    </>
  );
}

export default Carousal;
